<template>
  <div style="min-height: calc(100vh - 158px);" class="card">
    <div style="background: #DBE7F2" class="card p-2">
      <TitleButton
          :showBtn="false"
          title="Financial statements (datasheet)"
      />

      <div class="px-2">
        <DateQuerySetter
            btnTitle="Go"
            @onClickGo="onClickGo"
        >
          <div class="cols-12 col-sm-6 col-lg-4 col-xl-3">
            <label for="colFormLabel" class="col-form-label">Filter By</label>
            <v-select
                placeholder="Select Filter Option"
                :options="filterByOptions"
                label="name"
                :reduce="name => name.id"
                v-model="filterOption"
            />
          </div>
        </DateQuerySetter>
      </div>
    </div>

    <div class="card px-2">
      <div class="col-12 mb-1">
        <div class="d-flex justify-content-end px-2">
          <button
              @click="exportTable"
              class="btn btn-outline-secondary btn-sm btn-download-invoice waves-effect"
          >
            Export
          </button>
        </div>
      </div>

      <BalanceSheetColumnwiseTable
          :balances="balanceSheetData"
          :dynamicHeader="dynamicAllFilters"
          :total="total"
      />
    </div>

    <GlobalLoader/>
  </div>
</template>

<script setup>
import handleAccounting from '@/services/modules/accounting'
import handleInventory from "@/services/modules/inventory";

import {computed, inject, onMounted, ref} from 'vue'
import TitleButton                        from '@/components/atom/TitleButton'
import DateQuerySetter             from '@/components/atom/DateQuerySetter'
import BalanceSheetColumnwiseTable from '@/components/molecule/company/balance-sheet/BalanceSheetColumnwiseTable'
import {useRoute, useRouter}       from "vue-router";
import {useStore}                  from "vuex";

const router      = useRouter()
const route       = useRoute()
const showError   = inject('showError');
const showSuccess = inject('showSuccess');
const store       = useStore();

let balanceSheetData = ref([]);
let filterByOptions = ref([]);
let total = ref([]);
let dynamicAllFilters = ref([]);
let homeContent = ref([]);
let filterOption = ref("project");
let loader = ref(false)

const {
        getBalanceSheetColumnWise,
      } = handleAccounting()

const {fetchHome} = handleInventory()

const companyId = computed(() => {
  return route.params.companyId
})
const start = computed(() => {
  return route.query.start
})
const end = computed(() => {
  return route.query.end
})
const token = computed(() => {
  return localStorage.getItem('token')
})

function onClickGo() {
  getDateWiseBalanceSheetColumnWise(getQuery())
}

function getQuery() {
  let query = '?company_id=' + companyId.value
  if (!start.value && !end.value) return query
  if (start.value) query += '&start_date=' + start.value
  if (end.value) query += '&end_date=' + end.value
  if (filterOption.value) query += '&filter_option=' + filterOption.value

  return query
}

function getDateWiseBalanceSheetColumnWise(query = '') {
  if (! filterOption.value){
    showError('Please select a filter option');
    return;
  }

  loader.value = true;
  getBalanceSheetColumnWise(query)
  .then(function (res) {
    if (!res.status) {
      showError(res.message);
      balanceSheetData.value = [];
      dynamicAllFilters.value = [];
      total.value = [];
    }
    if (res.status) {
      balanceSheetData.value = res.data.data;
      dynamicAllFilters.value = res.data[`all_${filterOption.value}`];
      total.value = res.data.total;
    }
    loader.value = false
  })
  .catch(function (err) {
    loader.value = false
    if (!err.response) {
      showError('Something is wrong. Check your connectivity!!')
    }
    if (err.response?.data) {
      showError(err.response.data.message)
    }

    balanceSheetData.value = [];
    dynamicAllFilters.value = [];
    total.value = [];
  })
}

function prepareAllFilterOptions(){
  Object.keys(homeContent.value.fs_statement_filter_types).forEach((val)=>{
    filterByOptions.value.push({
      id : val,
      name : homeContent.value.fs_statement_filter_types[val],
    })
  });
}

function exportTable () {
  if (! filterOption.value){
    showError('Please select a filter option');
    return;
  }

  let url = `${process.env.VUE_APP_BASE_URL}/export/accounting/fs-datasheet` + getQuery() + `&_token=${token.value}`;
  let a = document.createElement("a")
  a.setAttribute("href", url)
  a.click()
}

onMounted(async () => {
  getDateWiseBalanceSheetColumnWise(getQuery());
  const getHomeContent = fetchHome(getQuery());

  Promise.all([
    getHomeContent.then(res => {
      if (res.status){
        homeContent.value = res.data;
        prepareAllFilterOptions();
      }
    })
  ])
  .then(() => {
    loader.value = false
  })
  .catch((err) => {
    loader.value = false
  })
})
</script>